/**
 * Converts a given date to a string representing the date in DD.MM.YYYY format
 * 
 * @param {Date} date The date to convert
 * @returns {string} The formatted date string in DD.MM.YYYY format
 */
export function toDate(date) {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + 1);
  const dateFormated = newDate
    .toLocaleString("es-CL", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    })
    .split("-");
    dateFormated[2] = dateFormated[2].slice(2, 4);
  return dateFormated.join(".")
}
/**
 * Converts a given date to a string representing the time in 24-hour format (h23),
 * adjusted by adding one day. The time is formatted according to the locale "es-CL".
 *
 * @param {Date} date - The date object to be converted.
 * @returns {string} The formatted time string in "hour:minute" format.
 */

export function toTime(date) {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + 1);
  return newDate.toLocaleString("es-CL", {
    hour: "numeric",
    minute: "numeric",
    hourCycle: "h23",
  });
}